$(function() {
	if (typeof ymaps != 'undefined' && $('#map-spb').length) {
		ymaps.ready(spbYMapsInit);
	}

	if (typeof ymaps != 'undefined' && $('#map-msk').length) {
		ymaps.ready(mskYMapsInit);
	}

	let spbMap, spbPlacemark;
	let mskMap, mskPlacemark;

	function spbYMapsInit() {
		spbMap = new ymaps.Map('map-spb', {
			center: [59.886912, 30.282702],
			zoom: 15,
			controls: ['zoomControl']
		});

		spbPlacemark = new ymaps.Placemark(
			[59.886912, 30.282702],
			{
				hintContent: 'Санкт-Петербург, улица Трефолева, дом 2, литера БМ'
			},
			{
				iconImageHref: '/assets/img/pin.svg',
				iconLayout: 'default#image',
				iconImageSize: [50, 50],
				iconImageOffset: [-50, -50]
			}
		);

		spbMap.behaviors.disable('scrollZoom');

		if (GG.config.responsive) {
			spbMap.behaviors.enable('multiTouch');
		}

		spbMap.geoObjects.add(spbPlacemark);
	}

	function mskYMapsInit() {
		mskMap = new ymaps.Map('map-msk', {
			center: [55.897629, 37.47775],
			zoom: 15,
			controls: ['zoomControl']
		});

		mskPlacemark = new ymaps.Placemark(
			[55.897629, 37.47775],
			{
				hintContent: 'МО, г. Химки, ул. Совхозная, 11'
			},
			{
				iconImageHref: '/assets/img/pin.svg',
				iconLayout: 'default#image',
				iconImageSize: [50, 50],
				iconImageOffset: [-50, -50]
			}
		);

		mskMap.behaviors.disable('scrollZoom');

		if (GG.config.responsive) {
			mskMap.behaviors.enable('multiTouch');
		}

		mskMap.geoObjects.add(mskPlacemark);
	}
});
